import React from 'react';
import DropdownSelector from '../../../components/actions/DropdownSelector';

export interface MenuOption {
  id: string;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface KpiCardMenuProps {
  options: MenuOption[];
}

/**
 * Dropdown menu for KPI cards with export and config options
 */
const KpiCardMenu: React.FC<KpiCardMenuProps> = ({ options }) => {
  return (
    <DropdownSelector
      onClick={e => {
        e.stopPropagation();
      }}
      DropAlignRight
      buttonTransparent
      vertical
      value={'...'}
      values={options.map(option => option.id)}
      renderValue={optionId => {
        const option = options.find(opt => opt.id === optionId);
        return option?.label || '';
      }}
      onChange={async (optionId, e) => {
        e.stopPropagation();
        const option = options.find(opt => opt.id === optionId);
        if (option && !option.disabled) {
          option.onClick();
        }
      }}
    />
  );
};

export default KpiCardMenu;
